import {
  addClass as _addClass,
  createEventBus as _createEventBus,
  debounce as _debounce,
  filterKeys as _filterKeys,
  focusFirstDescendant as _focusFirstDescendant,
  getStyleProperty as _getStyleProperty,
  getValueByPath as _getValueByPath,
  isFocusable as _isFocusable,
  isFunction as _isFunction,
  isKey as _isKey,
  isVisible as _isVisible,
  markSearchString as _markSearchString,
  memoize as _memoize,
  off as _off,
  on as _on,
  removeClass as _removeClass,
  setValueByPath as _setValueByPath,
  setValuesAlongPath as _setValuesAlongPath,
  toCamelCase as _toCamelCase,
  uid as _uid,
} from 'original-grozav-utils'

export function clone(source, parents = []) {
  for (const parent of parents) {
    if (parent === source) {
      return parent
    }
  }

  if (Array.isArray(source)) {
    const target = source.slice().map(_source => clone(_source, parents))
    const targetKeys = Object.keys(target)

    Object.keys(source)
      .filter(key => !targetKeys.includes(key))
      .forEach((key) => {
        target[key] = source[key]
      })

    return target
  }
  else if (
    typeof source === 'object'
    && source !== null
    && !(source instanceof Date)
    && !(source instanceof File)
    && !(source instanceof Set)
    && !(source instanceof Map)
  ) {
    return Object.keys(source).reduce((acc, key) => {
      acc[key] = clone(source[key], [...parents, source])
      return acc
    }, {})
  }

  return source
}

export const uid = _uid
export const isVisible = _isVisible
export const on = _on
export const off = _off
export const focusFirstDescendant = _focusFirstDescendant
export const getValueByPath = _getValueByPath
export const setValueByPath = _setValueByPath
export const setValuesAlongPath = _setValuesAlongPath
export const createEventBus = _createEventBus
export const isFunction = _isFunction
export const addClass = _addClass
export const removeClass = _removeClass
export const isKey = _isKey
export const isFocusable = _isFocusable
export const getStyleProperty = _getStyleProperty
export const toCamelCase = _toCamelCase
export const filterKeys = _filterKeys
export const memoize = _memoize
export const markSearchString = _markSearchString
export const debounce = _debounce
